import type {
  // CustomEdge,
  CustomNode,
  CustomNodeData,
} from '@src/components/custom-nodes/types';
// import {
//   getPrecededNodes,
// } from '@src/scenario-editor/utils';
import { NODES_TO_PASTE_CONDITION_AFTER } from '@src/consts';

export const checkIfSafeToDeleteConditionTargets = (
  nodeToRemove: CustomNode,
  // nodes: CustomNode[],
  // edges: CustomEdge[]
) => {
  if (!NODES_TO_PASTE_CONDITION_AFTER.includes((nodeToRemove.data as CustomNodeData)?.nodeType ?? '')) {
    return true;
  }

  // const ifStatementNodes = nodes.filter((n) => (n.data as CustomNodeData)?.nodeType === 'if:condition');

  // if (ifStatementNodes.length && nodeToRemove) {
  //   const ifStatementWithoutTarget = ifStatementNodes.filter((ifNode) => {
  //     const precededNodes = getPrecededNodes(ifNode, nodes, edges);
  //     const messageNodesWithAnswersLeft =
  //       precededNodes
  //         .filter((node) => (NODES_TO_PASTE_CONDITION_AFTER.includes((node.data as CustomNodeData)?.nodeType ?? '')))
  //         .filter((node) => (node.id !== nodeToRemove?.id));

  //     return !messageNodesWithAnswersLeft.length;
  //   });

  //   return !ifStatementWithoutTarget.length;
  // }

  return true;
}
